export const PLAYER_ICON = String.fromCodePoint(0x1F642);
export const MISSILE_ICON = String.fromCodePoint(0x1F680);
export const BALL_ICON = String.fromCodePoint(0x26BD);
export const COLOR_ICON = String.fromCodePoint(0x1F3A8);
export const HEIGHT_ICON = String.fromCodePoint(0x1F4CF);
export const JOYSTICK_ICON = String.fromCodePoint(0x1F579);
export const FIRE_ICON = String.fromCodePoint(0x1F518);
export const PLAYFIELD_ICON = String.fromCodePoint(0x1F5FA);
